(function () {
  'use strict';

  var config = window.SeaBearFreeGift || {};
  var marker = '_seabear_free_gift';
  var markerValue = 'threshold-promotion';
  var nativeFetch = window.fetch.bind(window);
  var syncPromise = null;
  var applyingDiscount = false;

  function isConfigured() {
    return Boolean(
      config.enabled &&
      Number(config.thresholdCents) > 0 &&
      Number(config.giftVariantId) > 0 &&
      Array.isArray(config.qualifyingProductIds) &&
      (config.qualifyingProductIds.length || config.qualifyingCollectionHandle)
    );
  }

  function isCartMutation(input, options) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((options && options.method) || (input && input.method) || 'GET').toUpperCase();
    return method !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url);
  }

  function qualifyingSubtotal(cart) {
    var qualifyingIds = config.qualifyingProductIds.map(Number);
    return cart.items.reduce(function (subtotal, item) {
      var isGift = item.properties && item.properties[marker] === markerValue;
      if (isGift || qualifyingIds.indexOf(Number(item.product_id)) === -1) return subtotal;
      return subtotal + Number(item.original_line_price || item.final_line_price || 0);
    }, 0);
  }

  function getQualifyingSubtotal(cart) {
    if (!config.qualifyingCollectionHandle) {
      return Promise.resolve(qualifyingSubtotal(cart));
    }

    var separator = config.eligibilitySectionUrl.indexOf('?') === -1 ? '?' : '&';
    var url = config.eligibilitySectionUrl + separator + '_=' + Date.now();
    return nativeFetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'text/html' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Free gift could not check collection eligibility.');
      return response.text();
    }).then(function (html) {
      var match = html.match(/data-free-gift-qualifying-subtotal=["'](\d+)["']/);
      if (!match) throw new Error('Free gift collection eligibility response was invalid.');
      return Number(match[1]);
    });
  }

  function promotionGiftLines(cart) {
    return cart.items.filter(function (item) {
      return Number(item.variant_id) === Number(config.giftVariantId) &&
        item.properties && item.properties[marker] === markerValue;
    });
  }

  function request(url, body) {
    return nativeFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('Free gift cart request failed with status ' + response.status);
      return response.json();
    });
  }

  function applyDiscountCode() {
    if (!config.discountCode || applyingDiscount) return Promise.resolve();
    applyingDiscount = true;
    return nativeFetch('/discount/' + encodeURIComponent(config.discountCode), {
      credentials: 'same-origin',
      redirect: 'follow'
    }).catch(function (error) {
      console.error('Free gift discount could not be applied.', error);
    }).then(function () {
      applyingDiscount = false;
    });
  }

  function reconcile() {
    if (!isConfigured()) return Promise.resolve(false);

    return nativeFetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Free gift could not read the cart.');
      return response.json();
    }).then(function (cart) {
      return getQualifyingSubtotal(cart).then(function (subtotal) {
      var eligible = subtotal >= Number(config.thresholdCents);
      var giftLines = promotionGiftLines(cart);
      var updates = {};

      if (eligible && giftLines.length === 0) {
        return applyDiscountCode().then(function () {
          return request('/cart/add.js', {
            items: [{
              id: Number(config.giftVariantId),
              quantity: 1,
              properties: (function () {
                var properties = {};
                properties[marker] = markerValue;
                return properties;
              }())
            }]
          });
        }).then(function () { return true; });
      }

      giftLines.forEach(function (item, index) {
        updates[item.key] = eligible && index === 0 ? 1 : 0;
      });

      if (giftLines.some(function (item, index) {
        return (!eligible || index > 0) || (index === 0 && item.quantity !== 1);
      })) {
        return request('/cart/update.js', { updates: updates }).then(function () { return true; });
      }

      return eligible ? applyDiscountCode().then(function () { return false; }) : false;
      });
    });
  }

  function sync() {
    if (syncPromise) return syncPromise;
    syncPromise = reconcile().then(function (changed) {
      if (changed) document.dispatchEvent(new CustomEvent('free-gift:updated'));
      return changed;
    }).catch(function (error) {
      console.error('Free gift promotion could not be synchronized.', error);
      return false;
    }).then(function (result) {
      syncPromise = null;
      return result;
    });
    return syncPromise;
  }

  if (!isConfigured()) return;

  window.fetch = function (input, options) {
    var cartMutation = isCartMutation(input, options);
    return nativeFetch(input, options).then(function (response) {
      if (!cartMutation || !response.ok) return response;
      return sync().then(function () { return response; });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
}());
